import { INotifications, IProjectNotifications, IProjectNotificationsRemove } from '@app/@introspection';
import { Inject } from '@rxdi/core';
import { Component, html, LitElement, property } from '@rxdi/lit-html';
import { ManRemoved } from '@shared/icons';

import { DateTimeProvider } from '../../date-time/date-time.service';

export const isProjectRemoveNotification = (n: INotifications) =>
  n.data.__typename === 'ProjectNotifications' && n.data.message.__typename === 'ProjectNotificationsRemove';

/**
 * @customElement project-remove-template-notifications
 */
@Component({
  selector: 'project-remove-template-notifications',
  template(this: ProjectRemoveTemplateComponent) {
    const data = this.notification.data as IProjectNotifications;
    const message = data.message as IProjectNotificationsRemove;

    return html`
      <style>
        .spacer {
          flex: 1 3 auto;
        }
      </style>
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 10px;">${ManRemoved}</div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            You have being removed from
            <a style="color: blue">${data.projectName}</a>
            by
            <a style="color: blue">${message.by.name}</a>
            reason ${message?.reason}
          </div>
          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
  },
})
export class ProjectRemoveTemplateComponent extends LitElement {
  @Inject(DateTimeProvider) private dateTimeProvider: DateTimeProvider;

  @property({ type: Object })
  notification: INotifications;
}
